export const MATERIALITY_TRACKER_MESSAGES = {
  OUTPUTS_LOCKED: 'Assessment results are currently locked. Please contact your administrator.',
};
